import { Group,Vector3, Geometry, Color, LineBasicMaterial, Line, WireframeGeometry, SphereGeometry, FontLoader, TextGeometry, MeshBasicMaterial, Mesh} from 'three';

class Crosshair extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        this.name = 'crosshair';

        var geometry = new Geometry();

	      geometry.vertices.push(new Vector3(.5, 0, 0));
        geometry.vertices.push(new Vector3(1.5, 0, 0));
	      const material = new LineBasicMaterial( {
	          color: new Color("rgb(255, 255, 255)"),
	          linewidth: 4,
            opacity: 0.7,
            visible: false,
            transparent: true,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );

        const line1 = new Line(geometry, material);
        const line2 = new Line(geometry, material);
        const line3 = new Line(geometry, material);
        const line4 = new Line(geometry, material);
        line2.rotation.z = 1.57;
        line3.rotation.z = 3.14;
        line4.rotation.z = -1.57;

        var loader = new FontLoader();
        const pointer = this;
        var textMaterial = new MeshBasicMaterial( 
            { color: new Color("rgb(10, 255, 10)"), opacity: 0.5,
            transparent: true,}
        );
        var textMaterial2 = new MeshBasicMaterial( 
            { color: new Color("rgb(255, 10, 10)"), opacity: 0.5,
              transparent: true, visible: false}
        );

        this.state = {
            mat: textMaterial,
            mat2: textMaterial2,
            mat3: material,
            lines: undefined,
            ready: true,
            die:  this.die.bind(this),
            score: 0,
            offset: 0,
        };

        loader.load( 'https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function ( font ) {
            var textGeometry = new TextGeometry( "HACK THE BEACONS", {
                font: font,
                size: 5,
                height: 1,
                curveSegments: 12,
                bevelThickness: .05,
                bevelSize: .1,
                bevelEnabled: true
            });
            var textGeometry2 = new TextGeometry( "        WASD To Move\n         Space To Jump\n Mouse To Aim And Shoot\n    Q To Use Power Ups\n            E To Pause", {
                font: font,
                size: 1.5,
                height: 1,
                curveSegments: 12,
                bevelThickness: .05,
                bevelSize: .1,
                bevelEnabled: true
            });
            var textGeometry3 = new TextGeometry( "Y O U   D I E D", {
                font: font,
                size: 5,
                height: 1,
                curveSegments: 12,
                bevelThickness: .05,
                bevelSize: .1,
                bevelEnabled: true
            });
            var textGeometry4 = new TextGeometry( "Press R to Restart", {
                font: font,
                size: 1.5,
                height: 1,
                curveSegments: 12,
                bevelThickness: .05,
                bevelSize: .1,
                bevelEnabled: true
            });
            var textGeometry5 = new TextGeometry( "Final Score:", {
                font: font,
                size: 1.5,
                height: 1,
                curveSegments: 12,
                bevelThickness: .05,
                bevelSize: .1,
                bevelEnabled: true
            });
            var mesh = new Mesh( textGeometry, textMaterial );
            mesh.position.x -= 33;
            mesh.position.y += 5;
            pointer.add( mesh );
            var mesh2 = new Mesh( textGeometry2, textMaterial );
            mesh2.position.x -= 11;
            mesh2.position.y += 2;
            pointer.add( mesh2 );

            var mesh3 = new Mesh( textGeometry3, textMaterial2 );
            mesh3.position.x -= 22;
            mesh3.position.y += 3;
            pointer.add( mesh3 );
            var mesh4 = new Mesh( textGeometry4, textMaterial2 );
            mesh4.position.x -= 9;
            mesh4.position.y -= 6;
            pointer.add( mesh4 );
            var mesh5 = new Mesh( textGeometry5, textMaterial2 );
            mesh5.position.x -= 6; 
            pointer.add( mesh5 );
        });

        //line.material = material;
        const g = new Group();

        g.add(line1);
        g.add(line2);
        g.add(line3);
        g.add(line4);
        this.add(g);
        this.state.lines = g;
        //this.add(sprite);
        this.position.y += 11;
        this.renderOrder = 999;
        material.depthTest = false;
        material.depthWrite = false;
        parent.addToUpdateList(this);
    }

    die(){
        if (this.state.ready){
            this.state.ready = false;
            this.state.lines.visible = false;
            this.state.mat2.visible = true;
            this.state.mat.visible = false;
            const pointer = this;
            var loader = new FontLoader();
            loader.load( 'https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function ( font ) {
                var textGeometry = new TextGeometry( pointer.state.score.toString(), {
                    font: font,
                    size: 1.5,
                    height: 1,
                    curveSegments: 12,
                    bevelThickness: .05,
                    bevelSize: .1,
                    bevelEnabled: true
                });
                textGeometry.center();
                var mesh = new Mesh( textGeometry, pointer.state.mat2 );
                mesh.position.y -= 2;
                mesh.position.x -= 1;
                pointer.add( mesh );
            });
        }
    }

    update(timeStamp) {
        if (timeStamp > 4000+this.state.offset && this.state.mat.opacity > 0){
            this.state.mat.opacity -= .01;
            if (this.state.mat.opacity <= 0){
                this.state.mat.visible = false;
                this.state.mat3.visible = true;
            }
        }
        if (this.state.lines.position.z > 0){
            this.state.lines.position.z -= 1;
        }
    }
}

export default Crosshair;
